import { Routes } from '@angular/router';
import { authGuard } from '@lite-workspace/shared/session';
import { ShellComponent } from './shell/shell.component';
import { NotificationSettingsPageComponent, NotificationsPageComponent } from '@lite-workspace/shared/blocks/notifications';

export const appRoutes: Routes = [
  {
    // Must precede the guarded shell route: the SSO redirect lands here with tokens in the URL
    // but not yet in storage, so the shell's authGuard would bounce back to login (redirect loop).
    path: 'auth/callback',
    loadComponent: () => import('./features/auth/auth-callback-lazy').then(m => m.AuthCallbackComponent),
  },
  {
    path: 'design-editor/:designPackageId',
    canMatch: [authGuard],
    loadComponent: () => import('./features/design-editor/design-editor-entry.component').then(m => m.DesignEditorEntryComponent),
    data: { title: 'Редактор шаблона' },
  },
  {
    path: '',
    component: ShellComponent,
    canMatch: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'users-list' },
      {
        path: 'users-list',
        loadChildren: () => import('./features/users/users.routes').then(m => m.USERS_ROUTES),
        data: { title: 'Пользователи' },
      },
      {
        path: 'users-requests',
        loadComponent: () =>
          import('./features/requests/feature/requests-list-page.component').then(m => m.RequestsListPageComponent),
        data: { title: 'Запросы на шаблоны' },
      },
      {
        path: 'partner-templates',
        loadComponent: () =>
          import('./features/requests/feature/requests-list-page.component').then(m => m.RequestsListPageComponent),
        data: { title: 'Шаблоны на проверке', partner: true },
      },
      {
        path: 'rental-requests',
        loadComponent: () =>
          import('./features/rental-requests/feature/rental-requests-page.component').then(m => m.RentalRequestsPageComponent),
        data: { title: 'Заявки на аренду' },
      },
      {
        path: 'webhook-events',
        loadComponent: () =>
          import('./features/webhook-events/feature/webhook-events-page.component').then(m => m.WebhookEventsPageComponent),
        data: { title: 'Журнал вебхуков' },
      },
      {
        path: 'fonts',
        loadComponent: () => import('./features/fonts/feature/fonts-list-page.component').then(m => m.FontsListPageComponent),
        data: { title: 'Шрифты' },
      },
      {
        path: 'print-services',
        loadChildren: () => import('./features/print-services/print-services.routes').then(m => m.PRINT_SERVICES_ROUTES),
        data: { title: 'Типографии' },
      },
      // Eager on purpose: the shell already statically imports this lib for the bell, so a lazy route
      // here would make it both a static and a dynamic dependency, which Nx forbids outright.
      { path: 'notifications', component: NotificationsPageComponent, data: { title: 'Уведомления' } },
      {
        path: 'notifications/settings',
        component: NotificationSettingsPageComponent,
        // Staff, not a photographer: no marketing mail switch here.
        data: { title: 'Настройки уведомлений', marketing: false },
      },
      {
        path: 'project-journey',
        loadComponent: () =>
          import('./features/project-journey/feature/project-journey-page.component').then(m => m.ProjectJourneyPageComponent),
        data: { title: 'Журнал проекта' },
      },
    ],
  },
];
